import './vendor.ts';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxWebstorageModule } from 'ngx-webstorage';

import { AuthInterceptor } from './blocks/interceptor/auth.interceptor';
import { ErrorHandlerInterceptor } from './blocks/interceptor/errorhandler.interceptor';
import { NewssoappSharedModule } from 'app/shared';
import { NewssoappCoreModule } from 'app/core';
import { NewssoappAppRoutingModule } from './app-routing.module';
import moment from 'moment';

// jhipster-needle-angular-add-module-import JHipster will add new module here
import { NewssoappSelfServiceModule } from './layouts/homepage/self-service.module';
import { SelfServiceComponent } from 'app/layouts/homepage/self-service.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LaddaModule } from 'app/layouts/homepage/directives/ladda.module';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { missingTranslationHandler, translatePartialLoader } from "./shared/config/translation.config";

@NgModule({
    imports: [
        BrowserModule,
        NgxWebstorageModule.forRoot({ prefix: 'jhi', separator: '-', caseSensitive: true }),
        NewssoappSharedModule.forRoot(),
        NewssoappCoreModule,
        FontAwesomeModule,
        NewssoappAppRoutingModule,
        NewssoappSelfServiceModule,
        LaddaModule.forRoot({
            style: 'contract',
            spinnerSize: 30,
            spinnerColor: 'white',
            spinnerLines: 12
        }),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: translatePartialLoader,
          deps: [HttpClient],
        },
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useFactory: missingTranslationHandler,
        },
      })
    ],
    declarations: [
        SelfServiceComponent
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorHandlerInterceptor,
            multi: true
        },
    ],
    bootstrap: [SelfServiceComponent]
})
export class NewssoappAppModule {
    constructor(private dpConfig: NgbDatepickerConfig) {
        this.dpConfig.minDate = { year: moment().year() - 100, month: 1, day: 1 };
    }
}
